// removed by extract-text-webpack-plugin
module.exports = {"label":"multi-email-input__label___2oPC5","error":"multi-email-input__error___3-Ghp","container":"multi-email-input__container___2AraU","textareaContainer":"multi-email-input__textareaContainer___BJpbG","chip":"multi-email-input__chip___1Db9S","chipError":"multi-email-input__chipError___QxIZF"};


//////////////////
// WEBPACK FOOTER
// ./core/src/components/form/multi-email-input.css
// module id = 1179
// module chunks = 0